<template>
    <div class="bussiness-intro-comp">
        <div class="user-shot">
            <div class="edit-wrap">
                <div class="member-shot">
                    <img v-if="companyInfo.files.length" class="shot" :src="companyInfo.files[0].blob" alt="">
                    <img v-else-if="companyInfo.avatarUrl" class="shot" :src="companyInfo.avatarUrl" alt="">
                    <img v-else class="shot" src="@/assets/img/shot.svg" alt="">
                </div>
                <file-upload
                    v-if="verifiedStatus === 'NORMAL'"
                    class="edit"
                    post-action="/upload/post"
                    :size="1024 * 5"
                    :maximum="1"
                    :multiple="true"
                    :drop="true"
                    :drop-directory="true"
                    v-model="companyInfo.files"
                    @input-file="inputFile"
                    @input-filter="inputFilter"
                    ref="upload">
                        <img src="@/assets/img/icon/shot_edit_black.svg" alt="" srcset="">
                </file-upload>
            </div>
            <div class="user-name">
                <div class="name">
                    {{companyInfo.companyName}}
                </div>
            </div>
        </div>
        <div class="biz-intro">
            <label class="button-font input-label">
                <div class="title">
                    <span class="must-fill"></span>
                    企業簡介
                </div>
                <span v-show="error.intro" class="error-with-title">{{error.intro}}</span>
            </label>
            <div class="input-arear">
                <div class="intro-container">
                    <pre class="pre"></pre>
                    <textarea id="add-description" @keyup="autoGrow()" :class="{error: error.intro}" v-model="companyInfo.intro" placeholder="介紹一下公司吧"></textarea>
                    <span class="des-count"><span class="count">{{companyInfo.intro?companyInfo.intro.length:'0'}}</span>/1000</span>
                </div>
            </div>
            <div class="input-note" @mouseenter="tipStatus.intro=true" @mouseleave="tipStatus.intro=false">租客會在哪裡看到企業簡介？</div>
            <title-tips v-if="tipStatus.intro" class="tips-intro" title="租客查看廣告詳情時" width="424px">
                <div class="content" slot="content">
                    <div class="biz-name">
                    <div class="shot-wrap">
                        <div class="company"></div>
                        <div class="shot">
                            <img v-if="companyInfo.files.length" class="shot-img" :src="companyInfo.files[0].blob" alt="">
                            <img v-else-if="companyInfo.avatarUrl" class="shot-img" :src="companyInfo.avatarUrl" alt="">
                            <img v-else class="shot-img" src="@/assets/img/shot.svg" alt="">
                        </div>
                    </div>
                    <div class="company-title">
                        {{companyInfo.companyName}}
                    </div>
                    </div>
                    <div class="biz-sub-title">
                       關於企業
                    </div>
                    <div class="biz-content" v-html="companyInfo.intro?companyInfo.intro.split('\n').join('<br>'):'您輸入的企業簡介會出現在這裡'">
                    </div>
                </div>
            </title-tips>
        </div>
    </div>
</template>
<script>
import FileUpload from 'vue-upload-component';
import titleTips from '@/components/bussiness/widges/tips/titleTips.vue';
import { mapGetters } from 'vuex'
import { 
    // 取得企業關於我
    apiBizGetCompanyIntro,
    // 新增編輯企業關於我
    apiBizSetCompanyIntro,
    // 取得企業相關圖片
    apiBizGetCompanyImages,
    // 上傳大頭照
    apiBizSetCompanyShot,
    baseDomain
    } from "@/apis/api.js"; 


export default {
    data () {
        return{
            companyInfo: {
                files: [],
                intro: null,
                companyName: null,
                avatarUrl: null,
            },
            error: {
                intro: null
            },
            tipStatus: {
                intro: false,
            },
        }
    },
    props: {
        submit: 0,
    },
    mounted () {
        this.getCompanyIntro()
        this.getCompanyShot()
    },
    watch: {
        submit: function (val) {
            // console.log(val)
            if(val){
                this.setCompanyIntro()
            }
        },
        'companyInfo.files': {
            handler: function (val) {
                this.setCompanyShot(val)
            },
            deep: true
        },
        'companyInfo.intro': function (val){
            if(val.length > 1000){
                this.error.intro = '限制1000字元以內'
            }else{
                this.error.intro = null
            }
        }
    },
    methods: {
        getCompanyIntro: function () {
            apiBizGetCompanyIntro()
            .then( res => {
                console.log('GetCompanyIntro',res)
                if(res.data.status == 'SUCCESS'){
                    this.companyInfo.intro = res.data.result.introduction
                    this.companyInfo.companyName = res.data.result.companyName
                    setTimeout(()=>{
                        this.autoGrow()
                    }, 300)
                }
            })
        },
        getCompanyShot: function () {
            apiBizGetCompanyImages('AVATAR')
            .then( res => {
                console.log('GetCompanyImages',res)
                if(res.status == 200){
                    this.companyInfo.avatarUrl = window.URL.createObjectURL(new Blob([res.data], { type: 'image/jpeg' }));
                }
            })
        },
        setCompanyIntro: function () {
            if(this.error.intro === null){
                let data = {
                    "introduction" : this.companyInfo.intro
                }
                apiBizSetCompanyIntro(data)
                .then( res => {
                    console.log('SetCompanyIntro',res)
                    if(res.data.status == 'SUCCESS'){
                        this.$store.dispatch('setAlarmStatus', {status: true,title: '儲存成功',type: 'success'})
                    }else{
                        this.$store.dispatch('setAlarmStatus', {status: true,title: errorMsg,type: 'error'})
                    }
                })
            }
            
        },
        setCompanyShot: function (file) {
            let formData = new FormData();
            console.log(file)
            formData.append('file', file[0].file);

            apiBizSetCompanyShot(formData)
            .then( res => {
                console.log(res)
                if(res.data.status == 'SUCCESS'){
                    // this.$store.dispatch('getUserStatus')
                    // location.reload();
                }
            })
        },
        imageUrl: function (url) {
            return baseDomain+url
        },
        autoGrow: function (){
            let textarea = document.getElementById('add-description')
            let adjustedHeight=textarea.clientHeight;
            console.log(adjustedHeight)
            adjustedHeight=Math.max(textarea.scrollHeight,adjustedHeight);
            // if (adjustedHeight>textarea.clientHeight){
                textarea.style.height=(adjustedHeight)+'px';
            // }
        },
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
                console.log('response', newFile)
        
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                    this.alart.fail = true
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '請上傳PDF、JPG或PNG檔案',type: 'error'})
                    return prevent()
                }

                if(newFile.size > (1024*1024*5)){
                    this.alart.fail = true
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '檔案最大限制5MB',type: 'error'})
                    return prevent()
                }
            }
            // console.log(newFile)
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        
    },
    computed: {
        userShot: function () {
            if( this.companyInfo.files.length){
                return this.companyInfo.files[0].blob
            }else if( this.companyInfo.avatarUrl ){
                return this.companyInfo.avatarUrl
            } 
        },
        ...mapGetters({
            userShot: 'GET_VERIFIED_USER_SHOT',
            verifiedStatus: 'GET_BIZ_COMPANY_IS_VERIFIED'
        })
    },
    components: {
        FileUpload,
        titleTips
    }
}
</script>
<style lang="scss" scoped>
    .bussiness-intro-comp{
        backdrop-filter: blur(10px);
        box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
        border: solid 1px #f3f3f3;
        background-color: #ffffff;
        padding: 24px;
        border-radius: 6px;
        min-height: 595px;
       .user-shot{
            display: flex;
            align-items: center;
            margin-bottom: 27px;
            .edit-wrap{
                position: relative;
                width: 80px;
                margin-right: 16px;
                .member-shot{
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 26px;
                    box-shadow: 0px 2px 4px rgba(165, 166, 187, 0.2);
                    width: 80px;
                    height: 80px;
                    overflow: hidden;
                    border-radius: 50%;
                    .shot{
                        width: 80px;
                    }
                }
                .edit{
                    position: absolute;
                    right: 0px;
                    bottom: 0px;
                    >label{
                        cursor: pointer;
                    }
                }
            }
            .user-name{
                display: flex;
                align-items: center;
                font-size: 20px;
                font-weight: 500;
            }
        }
        .biz-intro{
            width: 632px;
            min-height: 139px;
            .intro-container{
                position: relative;
                min-height: 139px;
                textarea{
                    position: relative;
                    top: 0px;
                    left: 0px;
                    min-height: 139px;
                    height: 100%;
                    padding: 12px 16px;
                    outline: 0;
                    resize: none;
                    overflow: hidden;
                }
                .des-count{
                    position: absolute;
                    z-index: 2;
                    right: 3px;
                    bottom: 3px;
                    color: #c5c2c1;
                    background: #fff;
                    width: 99%;
                    text-align: right;
                    padding-bottom: 3px;
                    .count{
                        color: #292625;
                    }
                }
                .pre{
                    display: block;
                    visibility: hidden;
                }
            }
            .tips-intro{
                .biz-name{
                    display: flex;
                    align-items: center;
                    font-size: 22px;
                    font-weight: 500;
                    margin-bottom: 18px;
                    img{
                        margin-right: 16px;
                    }
                }
                .biz-sub-title{
                    font-size: 16px;
                    font-weight: 500;
                    margin-bottom: 12px;
                }
                .biz-content{
                    line-height: 1.86;
                    color: #fc7171;
                    word-break: break-all;
                }
                .shot-wrap{
                    position: relative;
                    width: 60px;
                    height: 60px;
                    margin-right: 18px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                    .shot{
                        display: flex;
                        align-items: center;
                        .shot-img{
                            width: 100%;
                            background: #fff;
                            position: absolute;
                        }
                    }
                    .company{
                        width: 100%;
                        height: 100%;
                        background: url(data:image/svg+xml;base64,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);
                        background-repeat: no-repeat;
                        background-size: cover;
                        z-index: 9;
                    }
                    .shot{
                        position: absolute;
                        -webkit-box-sizing: border-box;
                        box-sizing: border-box;
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        .shot-img{
                            width: 100%;
                        }
                        .award{
                            position: absolute;
                            position: absolute;
                            bottom: -11px;
                            right: -5px;
                        }
                        
                    }
                }
                .company-title{
                    width: 310px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/settingCenter/bussinessIntro/bussinessIntrolComp.vue